import React, { useContext, useEffect, useState, createContext, ContextType } from 'react'
import { IChildren } from '../components/layout/index'

export interface IFiltro {
    titulo?: string
    descricao?: string
}

export interface IFiltroContex {
    children?: any
    filtro?: IFiltro[]
    setFiltro?: (e: any) => void
}

export interface IFiltroPgContext {
    children?: any
    filtroPg?: IFiltro[]
    setFiltroPg?: (e:any) => void
}
export interface IFiltroPgTipoContext {
    children?: any
    filtroTipoPg?: IFiltro[]
    setFiltroTipoPg?: (e:any) => void
}

export const FiltroDashContext = createContext<IFiltroContex>({});

export default function ProviderFiltroDash(props: IChildren) {
    
    const [filtro, setFiltro] = useState<Object[]>();
    
    return (
        <FiltroDashContext.Provider value={{ filtro, setFiltro }}>
            {
                props.children
            }
        </FiltroDashContext.Provider>
    )
}

export const FiltroDashPgContext = createContext<IFiltroPgContext>({});
export function ProviderFiltroDashPg(props: IChildren) {
    const [filtroPg, setFiltroPg] = useState<Object[]>();

    return (
        <FiltroDashPgContext.Provider value={{ filtroPg, setFiltroPg }}>
            {
                props.children
            }
        </FiltroDashPgContext.Provider>
    )
}


export const FiltroTipoPgContext = createContext<IFiltroPgTipoContext>({});
export function ProviderFiltroTipoPg(props: IChildren) {
    const [filtroTipoPg, setFiltroTipoPg] = useState<Object[]>();

    return (
        <FiltroTipoPgContext.Provider value={{ filtroTipoPg, setFiltroTipoPg }}>
        {
            props.children
        }
    </FiltroTipoPgContext.Provider>
    )
}